import React from "react";

// Images
import LockedPattern from "../../../../../Assets/Images/locked-pattern.png";

const Information = ({ title, Icon, rowSpan, colSpan, disabled }) => {
  return (
    <section
      className={`p-3 bg-dark-500 rounded-lg relative overflow-hidden ${
        rowSpan ? "row-span-" + rowSpan : "row-span-1"
      } ${colSpan ? "col-span-" + colSpan : "col-span-1"} `}
    >
      <section className="flex w-full justify-between">
        {/* Locked Image */}
        {disabled ? (
          <img
            src={LockedPattern}
            alt="Locked Pattern"
            className="absolute top-0 left-0 w-full opacity-50"
          />
        ) : (
          ""
        )}
        <h1 className="text-xl text-text-dark-500">{title}</h1>

        {Icon ? (
          <section className="bg-brand-500/50 w-[50px] h-[50px] rounded-full flex items-center justify-center">
            <Icon size={27.5} className="text-brand-500" weight="bold" />
          </section>
        ) : (
          <></>
        )}
      </section>
    </section>
  );
};

export default Information;
